module.exports = __webpack_public_path__ + "static/media/pstep2img5.9a2319f5.PNG";